import react from "react";
import axios from 'axios';
import Request from "../../../api/Requests";

const getInfoFormNightspot = (params) => {

    return Request('venues/info-form', 'GET', params, true);
}

const postFormNightspot = (params, action, tab, urlParams) => {
    params.action = action;
    params.tab = tab;
    if(urlParams.hasOwnProperty("plan")){
        params.plan = urlParams.plan;
    }
    return Request('venues/update-form', 'POST', params, true);
}

const getLocationQueryPlace = (q) => {
    let params = {
        "q": q
    }
    return Request('venues/location-query-place', 'POST', params, true);
}

const getLocationDetailPlace = (place_id) => {
    let params = {
        "place_id": place_id
    }
    return Request('venues/location-details-place', 'POST', params, true);
}

const getListNightspot = () => {
    return Request('venues/list', 'GET', {}, true);
}

const getgetVenuesContactList = (params) => {
    return Request('venues/list-venues-campaign-contacts', 'GET', params, true);
}

const uploadVenuesImages = async (id_venues, images, type) => {
    //return Request('venues/upload-venues-images', 'POST', params, true);
    var response = null;
    const formData = new FormData();
    
    const filesAsStrings = [...images].map((file) => file);
    
    filesAsStrings.forEach((file) => {
        formData.append('files[]', file);
      });
    formData.append('id_venues', id_venues);
    formData.append('type', type);
    let token = localStorage.getItem("token-api");
    axios.defaults.headers.common['Authorization'] = 'Bearer '+token;

    // Make the request
    await axios.post(process.env.REACT_APP_API_URL+'index.php?r=venues/upload-venues-images', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((dataResponse) =>{
        response = dataResponse
    }).catch((error) => {
        if(error.response.status === 401){
            localStorage.removeItem('token-api');
        }
    });
    if(response.status === 200){
        return response.data;
    }else{
        return null;
    }
}

const deleteVenuesImages = (id_venues, id) => {
    return Request('venues/delete-venues-images', 'POST', {id_venues:id_venues, id: id}, true);
}

const uploadExcelContacts = (params, form) => {
    let headers = {
        'Content-Type': 'multipart/form-data'
      }
    return Request('venues/upload-excel-contact-list&id='+params.id, 'POST', form, true, headers);
}

const importContactsFromFile = (params, file) => {
    return Request('venues/import-excel-contact-list&id='+params.id, 'POST', file, true,);
}

export default {
    getInfoFormNightspot,
    postFormNightspot,
    getLocationQueryPlace,
    getLocationDetailPlace,
    getListNightspot,
    getgetVenuesContactList,
    uploadVenuesImages,
    deleteVenuesImages,
    uploadExcelContacts,
    importContactsFromFile
}